import { useIsUser } from '@@client/lib/hooks'; // tests if not currently logged in as a User

export default function NotAuthenticated(_ref) {
  var children = _ref.children;
  var isUser = useIsUser();
  return isUser ? '' : children;
}